import { isEmpty } from "lodash";
import { months } from "../Admin/HeatpumpModels/components/AddModel";

export function addModelValidation(data) {
  let errors = {};

  if (!data?.model_name) {
    errors.model_name = "Model Name is required"
  }
  if (!data?.min_temp) {
    errors.min_temp = "Min Temp is required"
  }
  if (!data?.max_temp) {
    errors.max_temp = "Max Temp is required"
  }

  const remainingMonths = [];

  months.forEach(month => {
    if (!data?.monthGroups?.flatMap(g => g.selectedMonths)?.includes(month)) {
      remainingMonths.push(month.toUpperCase())
    }
  })

  if (remainingMonths?.length) {
    errors.low_temperature = `Low Temp is required for ${remainingMonths?.join(", ").toUpperCase()}`
  }

  if (data?.min_temp && data?.min_temp < 10) {
    errors.min_temp = "Min Temp should be greater than 10"
  }
  if (data?.max_temp && data?.max_temp < 10) {
    errors.max_temp = "Max Temp should be greater than 10"
  }
  if (data?.min_temp && data?.min_temp > 100) {
    errors.min_temp = "Min Temp should be less than 100"
  }
  if (data?.max_temp && data?.max_temp > 100) {
    errors.max_temp = "Max Temp should be less than 100"
  }
  if ((data?.min_temp && data?.max_temp) && (data?.min_temp >= 10 && data?.max_temp <= 100) && data?.min_temp > data?.max_temp) {
    errors.min_temp = "Min Temp should be less than Max Temp"
  }
  if ((data?.min_temp && data?.max_temp) && (data?.min_temp >= 10 && data?.max_temp <= 100) && data?.max_temp < data?.min_temp) {
    errors.max_temp = "Max Temp should be greater than Min Temp"
  }

  const greaterThan100Months = [];
  data?.monthGroups?.forEach(group => {
    if (group.temp && Number(group.temp) > 100) {
      group.selectedMonths.forEach(month => {
        greaterThan100Months.push(month.toUpperCase());
        errors[`${month}_low_temp`] = true;
      });
    }
  });

  if (greaterThan100Months.length) {
    errors.low_temperature = `Low Temp should be less than or equal to 100 for ${greaterThan100Months.join(", ")}`
  }

  if (!data?.boost_mode_exists?.toString()) {
    errors.boost_mode_exists = "Boost Mode is required"
  }
  return {
    isValid: isEmpty(errors),
    errors
  };
}
